import Ajv2019, { ValidateFunction } from 'ajv/dist/2019';
import { componentManifestSchema } from '../schema';
import type { WixComponentManifest } from '../schema';

export interface ComponentManifestValidatorResponse {
  valid: boolean;
  errors: Ajv2019['errors'];
}

let ajv: Ajv2019 | null = null;
let ajvValidate: ValidateFunction | null = null;

function componentManifestValidator(
  componentManifest: WixComponentManifest
): ComponentManifestValidatorResponse {
  if (!ajv || !ajvValidate) {
    ajv = new Ajv2019({ allErrors: true });
    ajvValidate = ajv.compile(componentManifestSchema);
  }

  const valid = ajvValidate(componentManifest);

  return {
    valid,
    errors: ajvValidate.errors
  };
}

export default componentManifestValidator;
